import { DrawerMenuItemList } from 'Components/Layout/DrawerMenu/DrawerMenuItemList'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { t } from 'ttag'

function SettingsDrawerMenuContent() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings`
  const drawerMenuNavLinks: NavLinkItem[] = [
    {
      title: t`Product parameters`,
      link: `${baseUrl}/product-parameters`
    },
    {
      title: t`VAT definitions`,
      link: `${baseUrl}/vat-definitions`
    },
    {
      title: t`Zone definitions`,
      link: `${baseUrl}/zone-definitions`
    },
    {
      title: t`Sales rules`,
      link: `${baseUrl}/sales-rules`
    }
  ]

  return <DrawerMenuItemList navLinks={drawerMenuNavLinks} rootUrl={baseUrl} />
}

export default SettingsDrawerMenuContent
